import { useQuery } from "react-query";
import { getTeacherRequiredDocuments } from "../services/school/teacher/getTeacherRequiredDocuments";
import { PagedRequestType } from "../types/PagedResults";
import { Key_teacherRequiredDocuments } from "../utils/constants";

export const useGetTeacherRequiredDocumentsQuery = (data: PagedRequestType) =>
  useQuery(
    [Key_teacherRequiredDocuments, JSON.stringify(data)],
    () => getTeacherRequiredDocuments(data)
  );